document.addEventListener("DOMContentLoaded", function () {
  const cordLabel = document.getElementById("ll-selected-cord");
  const customCaratSelect = document.getElementById("ll-custom-carat");
  const customCertRadios = document.querySelectorAll('input[name="ll_custom_cert"]');

  let productConfig = {
    cordAsVariant: false,
    defaultCord: "Bordeaux",
    productHandle: "",
    housing: "white",
    isNecklace: false,
    optionPositions: { cord: 1, carat: 2, cert: 3 },
  };
  let variants = [];
  let mediaLoadToken = 0;

  try {
    const configEl = document.getElementById("MultiProductConfig");
    if (configEl) productConfig = Object.assign(productConfig, JSON.parse(configEl.textContent));
  } catch (e) {
    console.warn("Could not parse MultiProductConfig", e);
  }

  try {
    const variantDataEl = document.getElementById("MultiVariantData");
    if (variantDataEl) variants = JSON.parse(variantDataEl.textContent);
  } catch (e) {
    console.warn("Could not parse MultiVariantData", e);
  }

  const cordAsVariant = Boolean(productConfig.cordAsVariant);
  const optionPositions = productConfig.optionPositions || { cord: 1, carat: 2, cert: 3 };

  function ensureMediaLoader() {
    const wrap = document.querySelector(".ll-cuty-media-item.ll-image-zoom");
    if (!wrap) return null;
    if (window.llSetMediaLoading) return wrap.querySelector("[data-ll-media-loader]");
    let loader = wrap.querySelector("[data-ll-media-loader]");
    if (loader) return loader;

    if (!document.getElementById("ll-media-loader-style")) {
      const style = document.createElement("style");
      style.id = "ll-media-loader-style";
      style.textContent = `
        .ll-cuty-media-item.ll-image-zoom.is-loading .ll-image-zoom__img {
          opacity: 0.55;
          transition: opacity 0.2s ease;
        }
        .ll-media-loader {
          position: absolute;
          inset: 0;
          z-index: 5;
          display: none;
          align-items: center;
          justify-content: center;
          pointer-events: none;
          background: rgba(255, 255, 255, 0.18);
        }
        .ll-cuty-media-item.ll-image-zoom.is-loading .ll-media-loader {
          display: flex;
        }
        .ll-media-loader__spinner {
          width: 2.8rem;
          height: 2.8rem;
          border: 2px solid rgba(93, 58, 94, 0.2);
          border-top-color: hsl(299, 20%, 31%);
          border-radius: 50%;
          animation: ll-media-spin 0.8s linear infinite;
        }
        @keyframes ll-media-spin {
          to { transform: rotate(360deg); }
        }
        @media (prefers-reduced-motion: reduce) {
          .ll-media-loader__spinner { animation: none; }
        }
      `;
      document.head.appendChild(style);
    }

    loader = document.createElement("div");
    loader.className = "ll-media-loader";
    loader.setAttribute("data-ll-media-loader", "");
    loader.setAttribute("aria-hidden", "true");
    loader.innerHTML = '<div class="ll-media-loader__spinner"></div>';
    wrap.appendChild(loader);
    return loader;
  }

  function setMediaLoading(isLoading) {
    const mainImage = document.getElementById("ll-cuty-main-image");
    if (window.llSetMediaLoading && mainImage) {
      window.llSetMediaLoading(mainImage, isLoading);
      return;
    }
    const wrap = document.querySelector(".ll-cuty-media-item.ll-image-zoom");
    if (!wrap) return;
    ensureMediaLoader();
    wrap.classList.toggle("is-loading", Boolean(isLoading));
  }

  function normalizeValue(value) {
    return (value || "").replace(/\s+/g, "").toLowerCase();
  }

  function normalizeCert(value) {
    return (value || "").toLowerCase().replace(/[\s-]/g, "");
  }

  function normalizeCarat(value) {
    return (value || "").toLowerCase().replace(/\s+/g, "");
  }

  function caratNumber(value) {
    const n = parseFloat(String(value || "").toLowerCase().replace("ct", "").trim());
    return Number.isNaN(n) ? null : n;
  }

  function caratsMatch(a, b) {
    const na = caratNumber(a);
    const nb = caratNumber(b);
    if (na != null && nb != null) return Math.abs(na - nb) < 0.001;
    return normalizeCarat(a) === normalizeCarat(b);
  }

  function getVariantOption(variant, position) {
    if (position === 1) return variant.option1;
    if (position === 2) return variant.option2;
    if (position === 3) return variant.option3;
    return null;
  }

  function isVariantCordMode() {
    return cordAsVariant && document.querySelector('input[name="ll_custom_cord"]');
  }

  function getSelectedCord() {
    const variantRadio = document.querySelector('input[name="ll_custom_cord"]:checked');
    if (variantRadio) return variantRadio.value;

    const propertyRadio = document.querySelector('input[name="properties[Cord Color]"]:checked');
    if (!propertyRadio) return productConfig.defaultCord || "Bordeaux";

    const swatch = propertyRadio.nextElementSibling;
    return swatch ? swatch.getAttribute("data-name") || propertyRadio.value : propertyRadio.value;
  }

  function getSelectedCarat() {
    return customCaratSelect ? customCaratSelect.value : "";
  }

  function getSelectedCert() {
    const checked = document.querySelector('input[name="ll_custom_cert"]:checked');
    return checked ? checked.value : "";
  }

  function setCordSelection(cordName) {
    if (!cordName) return;
    const wanted = normalizeValue(cordName);
    let matchedRadio = null;

    document.querySelectorAll('input[name="ll_custom_cord"]').forEach((radio) => {
      if (normalizeValue(radio.value) === wanted) {
        radio.checked = true;
        matchedRadio = radio;
      }
    });

    document.querySelectorAll('input[name="properties[Cord Color]"]').forEach((radio) => {
      const radioValue = radio.nextElementSibling?.getAttribute("data-name") || radio.value;
      if (normalizeValue(radioValue) === wanted) {
        radio.checked = true;
        matchedRadio = radio;
      }
    });

    if (cordLabel) {
      cordLabel.textContent = matchedRadio?.getAttribute("data-desc") || cordName;
    }
  }

  function currentImageMatchesCord(cordFmt) {
    const mainImage = document.getElementById("ll-cuty-main-image");
    if (!mainImage || !cordFmt) return false;
    /* Only trust the hero when it finished loading successfully (avoids skipping
       gallery refresh while a broken SSR .jpeg is pending or after it 404s). */
    if (!mainImage.complete || !mainImage.naturalWidth) return false;
    const src = String(mainImage.currentSrc || mainImage.getAttribute("src") || "").toLowerCase();
    const slug = String(cordFmt).toLowerCase();
    const hasCord = src.includes("-" + slug + ".") || src.includes("-attached-" + slug + ".");
    if (!hasCord) return false;
    if (isSoftHousingNecklace()) {
      const housing = (productConfig.housing || getInitialHousing()).toLowerCase();
      return src.includes("-" + housing + "-" + slug) || src.includes("-" + housing + "-attached-" + slug);
    }
    return true;
  }

  function setCaratSelection(caratValue) {
    if (!customCaratSelect || !caratValue) return;
    const normalized = normalizeCarat(caratValue);
    Array.from(customCaratSelect.options).forEach((opt) => {
      if (normalizeCarat(opt.value) === normalized) {
        customCaratSelect.value = opt.value;
      }
    });
  }

  function setCertSelection(certValue) {
    if (!certValue) return;
    const normalized = normalizeCert(certValue);
    customCertRadios.forEach((radio) => {
      if (normalizeCert(radio.value) === normalized) {
        radio.checked = true;
      }
    });
  }

  function findMatchingVariant() {
    const selectedCarat = getSelectedCarat();
    const certVal = normalizeCert(getSelectedCert());
    const cordVal = normalizeValue(getSelectedCord());
    const wantedCarat = caratNumber(selectedCarat);

    const matchesCert = (variant, certPos) =>
      normalizeCert(getVariantOption(variant, certPos)) === certVal;

    const closestCarat = (pool, caratPos) => {
      if (!pool.length) return null;
      if (wantedCarat == null) return pool[0];
      return pool.reduce((best, variant) => {
        const a = Math.abs((caratNumber(getVariantOption(variant, caratPos)) || 0) - wantedCarat);
        const b = Math.abs((caratNumber(getVariantOption(best, caratPos)) || 0) - wantedCarat);
        return a < b ? variant : best;
      });
    };

    if (isVariantCordMode()) {
      const cordPos = optionPositions.cord || 1;
      const caratPos = optionPositions.carat || 2;
      const certPos = optionPositions.cert || 3;
      const pool = variants.filter((v) => {
        return (
          normalizeValue(getVariantOption(v, cordPos)) === cordVal &&
          matchesCert(v, certPos)
        );
      });
      const exact = pool.find((v) => caratsMatch(getVariantOption(v, caratPos), selectedCarat));
      return exact || closestCarat(pool, caratPos);
    }

    const caratIsOption1 = variants.some((v) => caratNumber(v.option1) != null);
    const caratPos = caratIsOption1 ? 1 : 2;
    const certPos = caratIsOption1 ? 2 : 1;
    const pool = variants.filter((v) => matchesCert(v, certPos));
    const exact = pool.find((v) => caratsMatch(getVariantOption(v, caratPos), selectedCarat));
    return exact || closestCarat(pool, caratPos);
  }

  function getSelectedArrangement() {
    const radio = document.querySelector('input[name="properties[Arrangement]"]:checked');
    return (radio ? radio.value : "separated").toLowerCase();
  }

  function isAttachedArrangement() {
    const housing = (productConfig.housing || "white").toLowerCase();
    return getSelectedArrangement() === "attached" && housing !== "mix";
  }

  function formatCordSlug(selectedCord) {
    let cordFmt = selectedCord.toLowerCase().replace(/ /g, "-");
    const filenameMap = {
      "turq-blue": "turquoise",
      navy: "navy-blue",
      grey: "silver-grey",
      "yellow-gold": "gold",
      gold: "gold",
    };
    if (filenameMap[cordFmt]) {
      cordFmt = filenameMap[cordFmt];
    }
    return cordFmt;
  }

  function getProductHandle() {
    return productConfig.productHandle || window.MULTI_PRODUCT_HANDLE || window.location.pathname.split("/").pop();
  }

  function isNecklaceThreeProduct() {
    const handle = getProductHandle() || "";
    return handle.includes("multi-three-necklace");
  }

  function isSoftHousingNecklace() {
    const handle = getProductHandle() || "";
    return (
      handle.includes("multi-three-necklace") ||
      handle.includes("multi-four-necklace") ||
      handle.includes("multi-five-necklace")
    );
  }

  function getNecklaceDefaultHousing() {
    const handle = getProductHandle() || "";
    if (handle.includes("multi-three-necklace")) return "yellow";
    if (handle.includes("multi-four-necklace") || handle.includes("multi-five-necklace")) return "white";
    return "white";
  }

  function getHousingFromUrl() {
    if (!isSoftHousingNecklace()) return null;
    const param = new URL(window.location.href).searchParams.get("housing");
    if (isNecklaceThreeProduct()) {
      if (param === "mix" || param === "yellow" || param === "white" || param === "rose") {
        return param;
      }
      return null;
    }
    if (param === "yellow" || param === "white" || param === "rose") {
      return param;
    }
    return null;
  }

  function getInitialHousing() {
    const fromUrl = getHousingFromUrl();
    if (fromUrl) return fromUrl;
    if (isSoftHousingNecklace()) return getNecklaceDefaultHousing();
    return (productConfig.housing || "white").toLowerCase();
  }

  function getPillHousing(pill) {
    const dataHousing = pill.getAttribute("data-housing");
    if (dataHousing) return dataHousing;
    const href = pill.getAttribute("href") || "";
    const handle = href.split("/").pop() || "";
    return handle.replace(/^multi-three-/, "");
  }

  function updateGalleryAssetSample(housing) {
    if (!productConfig.galleryAssetSample) return;
    const sample = String(productConfig.galleryAssetSample);
    const handle = getProductHandle() || "";
    if (handle.includes("multi-three-necklace")) {
      productConfig.galleryAssetSample = sample.replace(
        /multi-three-necklace-[a-z]+-/i,
        "multi-three-necklace-" + housing + "-"
      );
      return;
    }
    if (handle.includes("multi-four-necklace")) {
      productConfig.galleryAssetSample = sample.replace(
        /multi-four-necklace-[a-z]+-/i,
        "multi-four-necklace-" + housing + "-"
      );
      return;
    }
    if (handle.includes("multi-five-necklace")) {
      productConfig.galleryAssetSample = sample.replace(
        /multi-five-necklace-[a-z]+-/i,
        "multi-five-necklace-" + housing + "-"
      );
      return;
    }
    productConfig.galleryAssetSample = sample.replace(/multi-three-[a-z]+-/i, "multi-three-" + housing + "-");
  }

  function buildThemeAssetUrls(cordFmt, handleOverride, housingOverride) {
    const productHandle = handleOverride || getProductHandle();
    const isNecklace = Boolean(productConfig.isNecklace) || productHandle.includes("necklace");
    const housing = (
      housingOverride ||
      productConfig.housing ||
      (isSoftHousingNecklace() ? getNecklaceDefaultHousing() : "white")
    ).toLowerCase();
    const attached = isAttachedArrangement();
    const newBase = isNecklace
      ? (attached
          ? `${productHandle}-${housing}-attached-${cordFmt}`
          : `${productHandle}-${housing}-${cordFmt}`)
      : (attached
          ? `${productHandle}-attached-${cordFmt}`
          : `${productHandle}-${cordFmt}`);
    const braceletAttachedBase = attached ? `multi-three-${housing}-attached-${cordFmt}` : null;
    const legacyBase = `${productHandle}-${cordFmt}`;
    const sample = productConfig.galleryAssetSample || window.SHOPIFY_ASSET_URL;

    if (sample) {
      try {
        const url = new URL(sample, window.location.origin);
        const parts = url.pathname.split("/");
        parts.pop();
        const buildUrl = (base, ext) => {
          if (!base) return null;
          const next = new URL(url.toString());
          next.pathname = [...parts, `${base}.${ext}`].join("/");
          next.search = "";
          return next.toString();
        };
        return {
          webp: buildUrl(newBase, "webp"),
          png: buildUrl(newBase, "png"),
          jpeg: buildUrl(newBase, "jpeg"),
          legacy: isNecklace && !attached ? buildUrl(legacyBase, "png") : null,
          braceletAttachedWebp: isNecklace ? buildUrl(braceletAttachedBase, "webp") : null,
          braceletAttachedPng: isNecklace ? buildUrl(braceletAttachedBase, "png") : null,
        };
      } catch (e) {
        /* fall through */
      }
    }

    return {
      webp: `${newBase}.webp`,
      png: `${newBase}.png`,
      jpeg: `${newBase}.jpeg`,
      legacy: isNecklace && !attached ? `${legacyBase}.png` : null,
      braceletAttachedWebp: isNecklace && braceletAttachedBase ? `${braceletAttachedBase}.webp` : null,
      braceletAttachedPng: isNecklace && braceletAttachedBase ? `${braceletAttachedBase}.png` : null,
    };
  }

  /* Keep current image until the next one is fully loaded (Cuty-style loader). */
  function loadMainImage(urls) {
    const mainImage = document.getElementById("ll-cuty-main-image");
    if (!mainImage) return Promise.resolve(false);

    if (window.llLoadProductImage) {
      return window.llLoadProductImage(mainImage, urls);
    }

    const token = ++mediaLoadToken;
    setMediaLoading(true);

    const candidates = [
      urls.webp,
      urls.png,
      urls.jpeg,
      urls.legacy,
      urls.braceletAttachedWebp,
      urls.braceletAttachedPng,
    ].filter(Boolean);

    return new Promise((resolve) => {
      let index = 0;

      const tryNext = () => {
        if (token !== mediaLoadToken) {
          resolve(false);
          return;
        }
        if (index >= candidates.length) {
          setMediaLoading(false);
          resolve(false);
          return;
        }

        const src = candidates[index++];
        const loader = new Image();
        loader.onload = () => {
          if (token !== mediaLoadToken) {
            resolve(false);
            return;
          }
          mainImage.src = loader.src;
          mainImage.removeAttribute("srcset");
          mainImage.style.opacity = "1";
          setMediaLoading(false);
          resolve(true);
        };
        loader.onerror = tryNext;
        loader.src = src;
      };

      tryNext();
    });
  }

  function updateGalleryImage() {
    const selectedCord = getSelectedCord();
    const checkedCord = document.querySelector(
      'input[name="ll_custom_cord"]:checked, input[name="properties[Cord Color]"]:checked'
    );
    if (cordLabel) {
      cordLabel.textContent = checkedCord?.getAttribute("data-desc") || selectedCord;
    }

    const cordFmt = formatCordSlug(selectedCord);
    return loadMainImage(buildThemeAssetUrls(cordFmt));
  }

  function updateCertificateAssets() {
    const certPreviewImg = document.getElementById("ll-multi-cert-preview-img");
    const modalImg = document.getElementById("ll-multi-modal-img");
    const modalDownload = document.getElementById("ll-multi-modal-download");
    const certMap = productConfig.certs || {};
    const key = caratNumber(getSelectedCarat());
    const cert =
      (key != null && (certMap[key.toFixed(2)] || certMap[String(key)] || certMap[key.toFixed(1)])) ||
      certMap["0.15"] ||
      certMap["0.20"] ||
      certMap["0.25"] ||
      null;

    if (!cert) return;

    if (cert.webp) {
      [certPreviewImg, modalImg].forEach((img) => {
        if (!img) return;
        img.src = cert.webp;
        img.style.display = "block";
        if (img === certPreviewImg && img.nextElementSibling) {
          img.nextElementSibling.style.display = "none";
        }
      });
    }

    if (modalDownload && (cert.pdf || cert.webp)) {
      modalDownload.href = cert.pdf || cert.webp;
    }
  }

  function applyMatchedVariant(matchedVariant) {
    if (!matchedVariant) {
      console.warn("Could not find matching Multi variant", {
        cord: getSelectedCord(),
        carat: getSelectedCarat(),
        cert: getSelectedCert(),
      });
      return;
    }

    document.querySelectorAll('input.product-variant-id, input[name="id"]').forEach((input) => {
      input.value = matchedVariant.id;
      input.disabled = false;
    });

    const newUrl = new URL(window.location.href);
    newUrl.searchParams.set("variant", matchedVariant.id);
    window.history.replaceState({}, "", newUrl.toString());

    if (matchedVariant.priceCents != null && window.theme && typeof theme.setProductPrices === 'function') {
      theme.setProductPrices(matchedVariant.priceCents);
    } else if (matchedVariant.price) {
      document.querySelectorAll("[id^='price-'][role='status'] .price-item--regular, [id^='price-'][role='status'] .price-item--sale, #dynamic-button-price").forEach((el) => {
        el.innerHTML = matchedVariant.price;
      });
    }

    if (window.updateAllSizeSubmitButtons) {
      window.updateAllSizeSubmitButtons();
    }
  }

  function syncNativeVariantPicker(options) {
    const opts = options || {};
    updateCertificateAssets();
    const matchedVariant = findMatchingVariant();
    applyMatchedVariant(matchedVariant);
    if (opts.skipGallery) return Promise.resolve(true);
    return updateGalleryImage();
  }

  function onCordChange() {
    syncNativeVariantPicker();
  }

  function preselectFromUrlVariant() {
    const urlVariantId = new URL(window.location.href).searchParams.get("variant");
    if (!urlVariantId || !variants.length) return;

    const matchedVariant = variants.find((v) => String(v.id) === String(urlVariantId));
    if (!matchedVariant) return;

    if (isVariantCordMode()) {
      setCordSelection(getVariantOption(matchedVariant, optionPositions.cord || 1));
      setCaratSelection(getVariantOption(matchedVariant, optionPositions.carat || 2));
      setCertSelection(getVariantOption(matchedVariant, optionPositions.cert || 3));
    } else {
      setCaratSelection(matchedVariant.option1);
      setCertSelection(matchedVariant.option2);
    }
  }

  function mapShopifyVariants(product) {
    return (product.variants || []).map((v) => ({
      id: v.id,
      option1: v.option1,
      option2: v.option2,
      option3: v.option3,
      price:
        typeof v.price === "number"
          ? window.theme && typeof theme.formatMoney === "function"
            ? theme.formatMoney(v.price)
            : typeof Shopify !== "undefined" && Shopify.formatMoney && window.theme && theme.moneyFormat
              ? Shopify.formatMoney(v.price, theme.moneyFormat)
              : String(v.price / 100)
          : v.price,
      featured_image: v.featured_image && (v.featured_image.src || v.featured_image),
    }));
  }

  function updateThreeHousingUi(housing) {
    const label =
      document.getElementById("ll-three-housing-label") ||
      document.getElementById("ll-multi-housing-label") ||
      document
        .querySelector(".ll-three-housing-swatches, .ll-multi-housing-dots")
        ?.closest(".ll-cuty-option-group")
        ?.querySelector(".ll-selected-value");
    const names = {
      yellow: "Yellow Gold",
      white: "White Gold",
      rose: "Rose Gold",
      mix: "Mix",
    };
    if (label) label.textContent = names[housing] || housing;

    document.querySelectorAll(".ll-three-housing-pill, .ll-multi-housing-swatch").forEach((pill) => {
      const pillHousing = getPillHousing(pill);
      const isActive = pillHousing === housing;
      pill.classList.toggle("is-active", isActive);
      pill.setAttribute("aria-current", isActive ? "true" : "false");
    });

    const mixWarning = document.querySelector(".ll-mix-warning");
    // React MultiThreeNecklace: no Separated Only banner on mix — only hide arrangement.
    // Bracelet mix products still use .ll-mix-warning.
    if (mixWarning && !isSoftHousingNecklace()) {
      mixWarning.style.display = housing === "mix" ? "" : "none";
    }

    const arrangementGroup = document
      .querySelector('input[name="properties[Arrangement]"]')
      ?.closest(".ll-cuty-option-group");
    if (arrangementGroup) {
      arrangementGroup.style.display = housing === "mix" ? "none" : "";
    }
  }

  async function softSwitchNecklaceHousing(event) {
    const pill = event.currentTarget;
    const housing = getPillHousing(pill);
    if (!housing || pill.classList.contains("is-active")) {
      event.preventDefault();
      return;
    }

    event.preventDefault();
    setMediaLoading(true);
    productConfig.housing = housing;
    updateGalleryAssetSample(housing);
    updateThreeHousingUi(housing);

    const cordFmt = formatCordSlug(getSelectedCord());
    await loadMainImage(buildThemeAssetUrls(cordFmt, null, housing));

    const url = new URL(window.location.href);
    url.searchParams.set("housing", housing);
    window.history.replaceState({ multiHousing: housing }, "", url.toString());
    syncNativeVariantPicker();
  }

  async function softSwitchThreeHousing(event) {
    const pill = event.currentTarget;
    const href = pill.getAttribute("href");
    if (!href || pill.classList.contains("is-active")) {
      event.preventDefault();
      return;
    }

    event.preventDefault();
    const handle = href.split("/").pop();
    const housing = handle.replace(/^multi-three-/, "");
    if (!housing) return;

    setMediaLoading(true);
    productConfig.productHandle = handle;
    productConfig.housing = housing;
    if (productConfig.galleryAssetSample) {
      updateGalleryAssetSample(housing);
    }

    updateThreeHousingUi(housing);

    const cordFmt = formatCordSlug(getSelectedCord());
    await loadMainImage(buildThemeAssetUrls(cordFmt, handle, housing));

    try {
      const product = await fetch(
        ((window.Shopify && Shopify.routes && Shopify.routes.root) || "/") +
          "products/" +
          handle +
          ".js"
      ).then((r) => {
        if (!r.ok) throw new Error("product fetch failed");
        return r.json();
      });
      variants = mapShopifyVariants(product);
      syncNativeVariantPicker();
      const url = new URL(href, window.location.origin);
      const matched = findMatchingVariant();
      if (matched) url.searchParams.set("variant", matched.id);
      window.history.pushState({ multiHousing: housing }, "", url.pathname + url.search);
    } catch (err) {
      console.warn("Soft housing switch failed, navigating", err);
      window.location.href = href;
    }
  }

  document
    .querySelectorAll('input[name="ll_custom_cord"], input[name="properties[Cord Color]"]')
    .forEach((radio) => radio.addEventListener("change", onCordChange));

  if (customCaratSelect) {
    customCaratSelect.addEventListener("change", syncNativeVariantPicker);
  }

  customCertRadios.forEach((radio) => {
    radio.addEventListener("change", syncNativeVariantPicker);
  });

  document.querySelectorAll('input[name="properties[Arrangement]"]').forEach((radio) => {
    radio.addEventListener("change", function () {
      syncNativeVariantPicker();
    });
  });

  document.querySelectorAll(".ll-three-housing-pill, .ll-multi-housing-swatch").forEach((pill) => {
    pill.addEventListener("click", function (event) {
      if (pill.hasAttribute("data-housing")) {
        softSwitchNecklaceHousing(event);
      } else {
        softSwitchThreeHousing(event);
      }
    });
  });

  window.addEventListener("popstate", function () {
    if (isSoftHousingNecklace()) {
      const housing = getHousingFromUrl() || getNecklaceDefaultHousing();
      productConfig.housing = housing;
      updateGalleryAssetSample(housing);
      updateThreeHousingUi(housing);
      const cordFmt = formatCordSlug(getSelectedCord());
      loadMainImage(buildThemeAssetUrls(cordFmt, null, housing));
      syncNativeVariantPicker();
      return;
    }

    const handle = window.location.pathname.split("/").pop() || "";
    if (!handle.startsWith("multi-three-")) return;
    const housing = handle.replace(/^multi-three-/, "");
    productConfig.productHandle = handle;
    productConfig.housing = housing;
    updateThreeHousingUi(housing);
    fetch(
      ((window.Shopify && Shopify.routes && Shopify.routes.root) || "/") +
        "products/" +
        handle +
        ".js"
    )
      .then((r) => r.json())
      .then((product) => {
        variants = mapShopifyVariants(product);
        preselectFromUrlVariant();
        syncNativeVariantPicker();
      })
      .catch(() => window.location.reload());
  });

  ensureMediaLoader();

  productConfig.housing = getInitialHousing();
  const softHousingNecklace = isSoftHousingNecklace();
  if (softHousingNecklace) {
    updateGalleryAssetSample(productConfig.housing);
    updateThreeHousingUi(productConfig.housing);
    const url = new URL(window.location.href);
    if (!url.searchParams.get("housing")) {
      url.searchParams.set("housing", productConfig.housing);
      window.history.replaceState({ multiHousing: productConfig.housing }, "", url.toString());
    }
  }

  preselectFromUrlVariant();

  if (!softHousingNecklace) {
    const url = new URL(window.location.href);
    if (url.searchParams.has("housing")) {
      url.searchParams.delete("housing");
      window.history.replaceState({}, "", url.toString());
    }
  }

  syncNativeVariantPicker({
    skipGallery: softHousingNecklace ? false : currentImageMatchesCord(formatCordSlug(getSelectedCord())),
  });

  window.addEventListener("pageshow", function (event) {
    if (!event.persisted) return;
    productConfig.housing = getInitialHousing();
    if (isSoftHousingNecklace()) {
      updateGalleryAssetSample(productConfig.housing);
      updateThreeHousingUi(productConfig.housing);
    }
    preselectFromUrlVariant();
    syncNativeVariantPicker({ skipGallery: false });
  });
});
